<app-header></app-header>
<app-home id="s1"></app-home>
<app-quiensomos id="s2"></app-quiensomos>
<app-sedes></app-sedes>
<app-instalaciones id="s3"></app-instalaciones>
<app-servicios id="s4"></app-servicios>
<!-- <app-personal id="s5"></app-personal> -->
<app-programa id="s6"></app-programa>
<app-contactanos id="s7"></app-contactanos>